import { useTVScale } from './TVScaleContext';

/**
 * Empty state del carril "Últimos resultados" cuando el torneo entra en fase
 * eliminatoria pero todavía no se jugó ningún cruce.
 *
 * Portado de `V5_Trophy` del mockup "Empty States · Últimos Resultados".
 * Mantiene paleta, animaciones (`esPulse`, `esTrophy` definidos en
 * `src/index.css`) y composición; usa `font-gilroy` para el título en lugar
 * de la Barlow Condensed del mockup, alineado con el resto del Modo TV.
 */
export const EmptyStateEliminatorias = () => {
  const { s } = useTVScale();
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        background:
          'linear-gradient(110deg, #011F52 0%, #023373 45%, #FF5A1D 140%)',
        borderRadius: 6,
      }}
    >
      {/* Halo naranja a la derecha */}
      <div
        style={{
          position: 'absolute',
          right: -30,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 180,
          height: 180,
          background:
            'radial-gradient(circle, rgba(255,90,29,.4) 0%, transparent 65%)',
        }}
      />
      {/* Patrón de bracket sutil al fondo */}
      <svg
        style={{ position: 'absolute', left: 0, top: 0, opacity: 0.08 }}
        width="100%"
        height="100%"
      >
        <defs>
          <pattern
            id="tv-empty-bracket"
            x="0"
            y="0"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M5 10 L20 10 L20 30 L35 30"
              stroke="#fff"
              strokeWidth="1"
              fill="none"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#tv-empty-bracket)" />
      </svg>

      <div
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: `${s(12)}px ${s(22)}px`,
          gap: s(20),
        }}
      >
        {/* Trofeo animado */}
        <div
          style={{
            flexShrink: 0,
            animation: 'esTrophy 2.4s ease-in-out infinite',
            transformOrigin: 'bottom center',
          }}
        >
          <svg viewBox="0 0 44 44" width={s(64)} height={s(64)}>
            <path
              d="M14 8 H30 V18 Q30 26 22 26 Q14 26 14 18 Z"
              fill="#FFC95A"
              stroke="#FF5A1D"
              strokeWidth="1.5"
            />
            <path
              d="M14 11 Q8 11 8 16 Q8 20 14 20"
              fill="none"
              stroke="#FFC95A"
              strokeWidth="2"
            />
            <path
              d="M30 11 Q36 11 36 16 Q36 20 30 20"
              fill="none"
              stroke="#FFC95A"
              strokeWidth="2"
            />
            <rect x="19" y="26" width="6" height="5" fill="#FFC95A" />
            <rect x="14" y="31" width="16" height="3" rx="1" fill="#FFC95A" />
            <rect x="11" y="34" width="22" height="3" rx="1" fill="#FF5A1D" />
          </svg>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: s(6),
              marginBottom: s(4),
            }}
          >
            <span
              style={{
                fontSize: s(12),
                fontWeight: 800,
                color: '#FFC95A',
                letterSpacing: '0.14em',
              }}
            >
              FASE FINAL
            </span>
          </div>
          <div
            className="font-gilroy"
            style={{
              fontSize: s(26),
              fontWeight: 900,
              color: '#fff',
              lineHeight: 1.05,
              letterSpacing: '0.02em',
              textTransform: 'uppercase',
            }}
          >
            Ahora se pone interesante
          </div>
          <div
            style={{
              fontSize: s(15),
              color: 'rgba(255,255,255,.82)',
              marginTop: s(5),
              fontWeight: 500,
            }}
          >
            Terminó la fase de grupos · en breve comienzan las eliminatorias
          </div>
        </div>
        <div
          style={{
            flexShrink: 0,
            background: '#FF5A1D',
            color: '#fff',
            padding: `${s(7)}px ${s(14)}px`,
            borderRadius: 4,
            fontSize: s(12),
            fontWeight: 800,
            letterSpacing: '0.1em',
            animation: 'esPulse 2s infinite',
          }}
        >
          BRACKET LISTO
        </div>
      </div>
    </div>
  );
};
